"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightningBondAbilityHandler = exports.LightningBondActorAbilityFactory = exports.LightningBondAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const ActorType_1 = require("../../core/actors/ActorType");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const ts_essentials_1 = require("ts-essentials");
const core_2 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
class LightningBondAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.LightningBond;
        this.__typeName = "LightningBond";
    }
}
exports.LightningBondAbilityArgs = LightningBondAbilityArgs;
let LightningBondActorAbilityFactory = class LightningBondActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("LightningBond", "Self", 4);
    }
};
LightningBondActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("LightningBond")
], LightningBondActorAbilityFactory);
exports.LightningBondActorAbilityFactory = LightningBondActorAbilityFactory;
let LightningBondAbilityHandler = class LightningBondAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const tempest = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
            .map(allyId => container.getActor(allyId))
            .find(actor => (actor === null || actor === void 0 ? void 0 : actor.classType) === ActorType_1.ActorType.Tempest);
        (0, ts_essentials_1.assert)(tempest, "TEMPEST_REQUIRED");
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalStrikeChance, 100),
                });
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: tempest.id,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalStrikeChance, 100),
                    onApplied(sequence) {
                        sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(tempest.id, "feet", "behind"), "BlueLightningOrb"));
                    }
                });
            }
        });
    }
};
LightningBondAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.LightningBond)
], LightningBondAbilityHandler);
exports.LightningBondAbilityHandler = LightningBondAbilityHandler;
